import React from 'react'
import {Grid, Dialog, DialogTitle, DialogContent} from '@material-ui/core'

import AppButton from '../AppButton'
import useStyles from './styles'
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'

export default function ConfirmationModal(props) {

    const {
            isWarning=true,
            fullWidth=false,
            dialogTitle,
            maxWidth,
            open,
            confirm,
            confirmText,
            confirmToolTip,
            deny,
            denyText,
            denyToolTip,
            title} = props

    const classes = useStyles({isWarning})

    return (
        <div>
            { title &&
                <Dialog
                    open={open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={fullWidth}
                    maxWidth={maxWidth}
                >
                    { dialogTitle &&
                        <DialogTitle>
                            <span className={classes.dialogTitle}>{dialogTitle}</span>
                        </DialogTitle>
                    }
                    <DialogContent>
                        <Grid container direction={'column'} spacing={2} className={classes.warningModal}>
                            <Grid container spacing={1} item>
                                { isWarning &&
                                    <Grid item xs={12} sm={1}>
                                        <div className={classes.warningIcon}>
                                            <ReportProblemOutlinedIcon />
                                        </div>
                                    </Grid>
                                }
                                <Grid item xs={12} sm={isWarning ? 11 : 12}>
                                    <div className={classes.warningText}>
                                        <span className={classes.title}>{title}</span>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container justify={'space-evenly'} spacing={1} item xs={12}>
                                { confirm && confirmText &&
                                    <Grid item>
                                        <AppButton
                                            onClick={ confirm }
                                            icon={<CheckCircleIcon />}
                                            id="MEDCAL_RX_MODAL_CONFIRM"
                                            tooltip={confirmToolTip}
                                            placement="bottom"
                                            text={confirmText}
                                        />
                                    </Grid>
                                }
                                { deny && denyText &&
                                    <Grid item>
                                        <AppButton
                                            onClick={ deny }
                                            icon={<CancelIcon />}
                                            id="MEDCAL_RX_MODAL_CONFIRM"
                                            variant={'outlined'}
                                            tooltip={denyToolTip}
                                            placement="bottom"
                                            text={denyText}
                                        />
                                    </Grid>
                                }
                            </Grid>

                        </Grid>
                    </DialogContent>
                </Dialog>
            }

        </div>
    );
}
